var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-page',{attrs:{"fixed":true}},[_c('w-loader-full')],1)}
var staticRenderFns = []

export { render, staticRenderFns }